"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlidersIcon = void 0;
const palette_1 = require("app/Theme/palette");
const react_1 = __importDefault(require("react"));
const SlidersIcon = () => {
    return (react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M4 21V14M4 10V3M12 21V12M12 8V3M20 21V16M20 12V3M1 14H7M9 8H15M17 16H23", stroke: palette_1.palette.BW_0, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" })));
};
exports.SlidersIcon = SlidersIcon;
